import { defaultTheme } from '@medly-components/theme';

import coral from './coral';
import darkBlue from './darkBlue';
import grey from './grey';
import royalBlue from './royalBlue';
import silverGrey from './silverGrey';
import yellow from './yellow';
import { error, errorBackground } from './common';

const colors = {
    ...defaultTheme.colors,
    grey,
    coral,
    royalBlue,
    darkBlue,
    silverGrey,
    yellow,
    error,
    errorBackground
};

export default colors;
